// 新闻状态枚举
export let newsStates = [
  {
    label: '未发布',
    value: 'DRAFT'
  },
  {
    label: '已发布',
    value: 'PUBLISHED'
  },
  {
    label: '已下架',
    value: 'DISABLED'
  }
]
// 新闻分组内排序方式
export let classifySortords = [
  {
    label: '按推荐值排序',
    value: 'RANKING'
  },
  {
    label: '按创建时间升序排列',
    value: 'CREATED_DATE_ASC'
  },
  {
    label: '按创建时间降序排列',
    value: 'CREATED_DATE_DESC'
  }
]
